
import axios from "axios";
axios.defaults.withCredentials = true;
export default axios.create({
  baseURL: 'https://fx-global.soccerslot.xyz',
  headers: {
    "Content-type": "application/json",
    withCredentials: true,
  }
});
